import history from '../history';


export default function setupGlobalNavigation(store) {
  // Add global function to navigate
  window._utils.push = (...args) => history.push(...args);
  window._utils.replace = (...args) => history.replace(...args);
}
